import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import DashboardPages from "../../../Dashboard/DashboardPages";
import Tables from "../../../components/Tables";
import {
  TYPE_CHECK_DASHBOARD,
  TYPE_GET_DATE,
  tableMagicWheelDailyRevenue,
} from "../../../../helper/const";
import DailyRevenueChartMagicWheel from "../../../components/DailyRevenueChartMagicWheel";
import _ from "lodash";
import {
  formatDataDailyRevenueChartMagicWheel,
  formatDataNumberToen,
  formatDataQuantityMytelMagicWeelOverview,
  formatDataStatisticTableMagicWheel,
  getDateChangeTime,
} from "../../../../helper/helper";
import { selectorDataMagicWeel } from "../../../../redux/selector";
import FilterTime from "../../../components/FilterTime";
import RevenueOfChannelChart from "../../../components/RevenueOfChannelChart";
import styled from "styled-components";

export default function Overview({ handleGetData, tabActive }) {
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  const { revenue = {} } = useSelector(selectorDataMagicWeel);
  const {
    dataList = [],
    dataOverview = [],
    dataDetail = [],
  } = revenue.result || {};
  let dataDailyRevenueChart = [];

  useEffect(() => {
    if (tabActive !== "1") return;
    // dispatch(getDataMagicWheel(apiRevenueMagicWheel(startDate, endDate)));
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: [],
    xField: "time",
    yField: ["totalRevenue", "quantity"],

    annotations: {
      quantity: [],
    },
  };

  let columnsMagicRevenue = { dataKey: [], defineData: [] };
  let revenueOfChannel = {
    data: [],
    xField: "type",
    yField: ["revenue"],
  };

  useMemo(() => {
    quantityRevenue = formatDataQuantityMytelMagicWeelOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.overview
    );

    revenueOfChannel = formatDataQuantityMytelMagicWeelOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.revenue
    );

    columnsMagicRevenue = formatDataStatisticTableMagicWheel(dataOverview);

    dataDailyRevenueChart = formatDataDailyRevenueChartMagicWheel(dataDetail);

    //Daily Revenue Table

    // const formatDataApi = dataDetail.map((item = {}) => {
    //   const {
    //     chargeTime = 0,
    //     packs,
    //     value = 0,
    //     total_reg_revenue = 0,
    //     total_renew_revenue = 0,
    //   } = item;
    //   const defineDataDailyRevenueTable = {
    //     MAGIC_DAILY: 0,
    //     MAGIC_WEEKLY: 0,
    //     MAGIC_MONTHLY: 0,
    //     MAGIC_BUY3: 0,
    //     MAGIC_BUY5: 0,
    //     MAGIC_BUY10: 0,
    //     MAGIC_BUY50: 0,
    //   };
    //   packs.forEach((packItem = {}) => {
    //     const idPack = packItem.id;
    //     defineDataDailyRevenueTable[idPack] = packItem.amount;
    //   });
    //   return {
    //     Chargetime: chargeTime,
    //     Day: defineDataDailyRevenueTable.MAGIC_DAILY,
    //     Week: defineDataDailyRevenueTable.MAGIC_WEEKLY,
    //     Month: defineDataDailyRevenueTable.MAGIC_MONTHLY,
    //     BUY3: defineDataDailyRevenueTable.MAGIC_BUY3,
    //     BUY5: defineDataDailyRevenueTable.MAGIC_BUY5,
    //     BUY10: defineDataDailyRevenueTable.MAGIC_BUY10,
    //     BUY50: defineDataDailyRevenueTable.MAGIC_BUY50,
    //     RegisterRevenue: total_reg_revenue,
    //     RenewRevenue: total_renew_revenue,
    //     RetailRevenue: 0,
    //     TotalRevenue: value,
    //   };
    // });

   

    const formatDataApi = dataDetail.map((item = {}) => {
      const {
        chargeTime = 0,
        packs = [],
        value = 0,
        total_renew_revenue = 0,
      } = item;

      const defineDataDailyRevenueTable = {
        MAGIC_DAILY: 0,
        MAGIC_WEEKLY: 0,
        MAGIC_MONTHLY: 0,
        MAGIC_BUY3: 0,
        MAGIC_BUY5: 0,
        MAGIC_BUY10: 0,
        MAGIC_BUY50: 0,
      };

      let RegisterRevenue = 0;

      packs.forEach((packItem = {}) => {
        const idPack = packItem.id;

        defineDataDailyRevenueTable[idPack] =
          (defineDataDailyRevenueTable[idPack] || 0) + (packItem.amount || 0);

        if (
          idPack === "MAGIC_DAILY" ||
          idPack === "MAGIC_WEEKLY" ||
          idPack === "MAGIC_MONTHLY"
        ) {
          RegisterRevenue += packItem.total_reg_revenue || 0;
        }
      });

      const RetailRevenue =
        defineDataDailyRevenueTable.MAGIC_BUY3 +
        defineDataDailyRevenueTable.MAGIC_BUY5 +
        defineDataDailyRevenueTable.MAGIC_BUY10 +
        defineDataDailyRevenueTable.MAGIC_BUY50;

      return {
        Chargetime: chargeTime,
        Day: defineDataDailyRevenueTable.MAGIC_DAILY,
        Week: defineDataDailyRevenueTable.MAGIC_WEEKLY,
        Month: defineDataDailyRevenueTable.MAGIC_MONTHLY,
        BUY3: defineDataDailyRevenueTable.MAGIC_BUY3,
        BUY5: defineDataDailyRevenueTable.MAGIC_BUY5,
        BUY10: defineDataDailyRevenueTable.MAGIC_BUY10,
        BUY50: defineDataDailyRevenueTable.MAGIC_BUY50,
        RegisterRevenue,          
        RenewRevenue: total_renew_revenue,
        RetailRevenue,
        TotalRevenue: value,
      };
    });


    
    let total = {
      BUY3: 0,
      BUY5: 0,
      BUY10: 0,
      BUY50: 0,
      Chargetime: "Total",
      Day: 0,
      TotalRevenue: 0,
      RetailRevenue: 0,
      RenewRevenue: 0,
      RegisterRevenue: 0,
      Month: 0,
      Week: 0,
    };

    formatDataApi.forEach((item) => {
      total.Day += item.Day || 0;
      total.Week += item.Week || 0;
      total.Month += item.Month || 0;
      total.BUY3 += item.BUY3 || 0;
      total.BUY5 += item.BUY5 || 0;
      total.BUY10 += item.BUY10 || 0;
      total.BUY50 += item.BUY50 || 0;
      total.TotalRevenue += item.TotalRevenue || 0;
      total.RenewRevenue += item.RenewRevenue || 0;
      total.RegisterRevenue += item.RegisterRevenue || 0;
      total.RetailRevenue += item.RetailRevenue || 0;
    });

    for (const key in total) {
      if (typeof total[key] === "number") {
        total[key] = parseFloat(total[key].toFixed(3));
      }
    }
    let data = [total, ...formatDataApi].reverse();
    tableMagicWheelDailyRevenue.defineData = data.map((item) => {
      for (let x in item) {
        if (typeof item[x] === "number") {
          item[x] = formatDataNumberToen(item[x]);
        }
      }
      return item;
    });
  }, [revenue.result]);

  return (
    <Container className="reponsitite-container">
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <Row className="panel panel-sortable">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24}>
            <Row>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">
                  Overview Quantity - Revenue chart:
                </h4>
                <div className="item-chart">
                  <DashboardPages dataDashboard={quantityRevenue} />
                </div>
              </Col>
              <Col
                xxl={12}
                xl={12}
                lg={12}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">Revenue of channel chart:</h4>

                <div className="item-chart">
                  <RevenueOfChannelChart dataChart={revenueOfChannel} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div id="table-bitel">
        <Tables
          columns={columnsMagicRevenue}
          title="Overview statistic table"
          isHiddenPagination={false}
        />
      </div>
      <div className="container-dashboard pt-0">
        <Row className="panel panel-sortable">
          <Title titleName="Daily Revenue Chart">
            <BranchesOutlined />
          </Title>
          <div className="container-revenueOfChannelChart">
            <div className="revenueOfChannelChart">
              <DailyRevenueChartMagicWheel
                dataRevenueChart={dataDailyRevenueChart}
              />
            </div>
          </div>
        </Row>
      </div>
      <Tables
        columns={tableMagicWheelDailyRevenue}
        title="Daily Revenue Table"
      />
      {/* <ProjectInformation id={idProject.mytel} /> */}
    </Container>
  );
}

const Container = styled.div`
  .container-revenueOfChannelChart {
    width: 100%;
    overflow-x: auto;
  }

  .revenueOfChannelChart {
    min-width: 800px;
    overflow-x: scroll;
  }
`;
